import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import i18n from './i18n/i18n'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import './style/style.css'
import './components/'
import locale from 'iview/dist/locale/en-US';
import mixin from './mixin'
import * as context from './common/context'
import store from './store'
// import locale from 'iview/dist/locale/zh-CN';

Vue.use(iView, { locale });

Object.assign(Vue.prototype, context)
Vue.config.productionTip = false
Vue.mixin(mixin)
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
